import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Alert,
  Stack,
} from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { AppButton } from '../design-system';
import { getRouteEntitlementLabel } from '../../utils/routeEntitlement';
import { appNavigate } from '../../utils/appNavigate';
import { buildTenantPath } from '../../utils/tenantNavigation';
import { useSubdomain } from '../../contexts/SubdomainContext';

interface RouteEntitlementBlockedProps {
  routeKey: string;
}

/**
 * Shown when a tenant user navigates directly to a route their subscription modules do not include.
 */
export const RouteEntitlementBlocked: React.FC<RouteEntitlementBlockedProps> = ({ routeKey }) => {
  const { subdomain } = useSubdomain();
  const featureLabel = getRouteEntitlementLabel(routeKey);

  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 4 }}>
      <Card elevation={2}>
        <CardContent>
          <Stack spacing={3} alignItems="center" textAlign="center" py={4}>
            <LockIcon color="disabled" sx={{ fontSize: 56 }} />
            <Typography variant="h5" component="h1">
              Feature not available
            </Typography>
            <Alert severity="info" sx={{ width: '100%', textAlign: 'left' }}>
              <strong>{featureLabel}</strong> is not included in your organization&apos;s current
              subscription modules. Contact your administrator to upgrade or enable the required CCI module.
            </Alert>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
              <AppButton variant="contained" onClick={() => appNavigate(buildTenantPath('/', subdomain))}>
                Go to dashboard
              </AppButton>
              <AppButton variant="outlined" onClick={() => appNavigate(buildTenantPath('/billing', subdomain))}>
                View billing
              </AppButton>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
};

export default RouteEntitlementBlocked;
